import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { Cluster, ClusterService } from 'src/app/core/cluster.service';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-cluster-data',
  templateUrl: './cluster-data.component.html',
  styleUrls: ['./cluster-data.component.scss'],
})
export class ClusterDataComponent {
  @ViewChild('cluster_load_more') load_more_layout?: ElementRef;
  @Output() refresh: EventEmitter<void> = new EventEmitter<void>();
  is_list_running: boolean = true;
  is_load_more_running: boolean = true;
  clusters?: Cluster[];
  cursor: string | null = null;
  total?: number;
  skeleton_rows: number[] = [1, 2, 3, 4, 5];

  constructor(private cluster_service: ClusterService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.clusters = [];
    this.cursor = null;
    this.total = undefined;
    this.listClusters();
  }

  onRefresh(): void {
    this.clusters = [];
    this.total = undefined;
    this.cursor = null;
    this.listClusters();
  }

  onScrollEnd(): void {
    if (this.cursor && !this.is_load_more_running) this.onLoadMoreClick();
  }

  onLoadMoreClick(): void {
    this.listClusters(true);
  }

  listClusters(is_load_more_running?: boolean): void {
    this.is_list_running = !is_load_more_running;
    this.is_load_more_running = is_load_more_running || false;

    this.cluster_service.listClusters({ cursor: this.cursor }).subscribe({
      next: response => {
        const clusters: Cluster[] = response.data.data;
        const should_use_mock_clusters = this.isMockEnvironment() && clusters.length === 0 && !this.cursor;
        const clusters_to_display = should_use_mock_clusters ? this.getMockClusters() : clusters;
        this.clusters = (this.clusters ? this.clusters : []).concat(clusters_to_display);
        this.cursor = should_use_mock_clusters ? null : response.data.cursor;
        this.total = should_use_mock_clusters ? clusters_to_display.length : response.data.total.value;
        this.is_list_running = false;
        this.is_load_more_running = false;
      },
      error: error => {
        const error_status = error?.status ?? error?.statusCode ?? error?.response?.status;
        // TODO: Remove this fallback when cluster data is available in dev/local environments.
        if (this.isMockEnvironment() && error_status === 500 && !this.cursor) {
          this.clusters = this.getMockClusters();
          this.total = this.clusters.length;
          this.cursor = null;
          this.is_list_running = false;
          this.is_load_more_running = false;
          return;
        }

        const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
        this.error_service.processApiError(processed_error.code, processed_error.message);
        this.is_list_running = false;
        this.is_load_more_running = false;
      },
    });
  }

  private isMockEnvironment(): boolean {
    return ['local', 'dev', 'development', 'aminolfi'].includes(environment.STAGE.toLowerCase());
  }

  private getMockClusters(): Cluster[] {
    const valid_from = Date.now();
    const valid_to = new Date(valid_from);
    valid_to.setFullYear(valid_to.getFullYear() + 1);

    return [
      {
        cluster_id: 'cls_mock_retail',
        cluster_code: 'MOCK_RETAIL',
        name: 'Mock Retail Cluster',
        valid_from,
        valid_to: valid_to.getTime(),
        configurations: [
          {
            steps_number: 3,
            min_amount: 10000,
            max_amount: 100000,
            goal_tan: 500,
            min_tan: 0,
            max_tan: 700,
          },
          {
            steps_number: 6,
            min_amount: 10000,
            max_amount: 100000,
            goal_tan: 650,
            min_tan: 0,
            max_tan: 850,
          },
        ],
      },
      {
        cluster_id: 'cls_mock_professional',
        cluster_code: 'MOCK_PROFESSIONAL',
        name: 'Mock Professional Cluster',
        valid_from,
        valid_to: valid_to.getTime(),
        configurations: [
          {
            steps_number: 12,
            min_amount: 25000,
            max_amount: 250000,
            goal_tan: 750,
            min_tan: 0,
            max_tan: 950,
          },
        ],
      },
    ];
  }
}
